import { validateEmail } from './../utils'
import _ from 'lodash'
import API from './../../api'
import AuthUser from "../../auth";
import router from "@/router";

const DEFAULT_SERVER_SIDE_RESPONSE = {
  "hasResponse": false,
  "responseType": '',
  "header": "",
  "message": ""
};

const DEFAULT_SEARCH_FORM = {
  unit: "",
  address: "",
  addressValidation: "",
  email: "",
  emailValidation: "",
};

const DEFAULT_AUTO_COMPLETE = {
  isOpen: false,
  results: [],
  arrowCounter: -1,
}

/**
 * Person Form Validator
 */
export default {
  namespaced: true,
  state: {
    serverSideResponse: _.clone(DEFAULT_SERVER_SIDE_RESPONSE),
    searchForm: _.clone(DEFAULT_SEARCH_FORM),
    autoComplete: _.clone(DEFAULT_AUTO_COMPLETE),
  },
  mutations: {
    setServerSideResponse (state, response) {
      state.serverSideResponse = response
    },
    setFormValue (state, form) {
      state.searchForm = _.merge(state.searchForm, form);
    },
    setAutoCompleteResponse (state, autoCompleteResponse) {
      state.autoComplete = autoCompleteResponse;
    },
    resetAutoComplete (state) {
      state.autoComplete = DEFAULT_AUTO_COMPLETE;
    },
    setResult(state, result) {
      state.searchForm.address = result;
      state.autoComplete.isOpen = false;
    },
    onArrowDown(state) {
      if (state.autoComplete.arrowCounter < state.autoComplete.results.length) {
        state.autoComplete.arrowCounter = state.autoComplete.arrowCounter + 1;
      }
    },
    onArrowUp(state) {
      if (state.autoComplete.arrowCounter > 0) {
        state.autoComplete.arrowCounter = state.autoComplete.arrowCounter - 1;
      }
    },
    onEnter(state) {
      state.searchForm.address = state.autoComplete.results[state.autoComplete.arrowCounter];
      state.autoComplete.isOpen = false;
      state.autoComplete.arrowCounter = -1;
    },
  },
  actions: {
    resetForm: async ({ commit }) => {
      commit('setLoading', false, { root: true })
      commit('setFormValue', _.clone(DEFAULT_SEARCH_FORM));
      commit('setServerSideResponse', _.clone(DEFAULT_SERVER_SIDE_RESPONSE));
    },

    /**
     * Get a page
     * @param commit
     * @param pageID
     * @returns {Promise<void>}
     */
    search: async ({ commit, state }) => {
      commit('setLoading', true, { root: true })
      try {
        let user = AuthUser.getAuthUser();
        let address = state.searchForm.address.trim();
        let email = state.searchForm.email.trim() || user.email;

        if (_.isEmpty(address)) {
          commit('setLoading', false, { root: true })
          commit('setFormValue', {
            addressValidation: 'is-invalid',
          });
          return ;
        }
        commit('setFormValue', {
          addressValidation: 'is-valid',
        });


        if (_.isEmpty(email) || validateEmail(email) === false) {
          commit('setLoading', false, { root: true })
          commit('setFormValue', {
            emailValidation: 'is-invalid',
          });
          return;
        }
        commit('setFormValue', {
          emailValidation: 'is-valid',
        });


        //ok, form validation passed, let's reset the form
        let response = await API.submitSearch(state.searchForm.unit, state.searchForm.address, email);
        commit('setLoading', false, { root: true });
        commit('setFormValue', DEFAULT_SEARCH_FORM);
        if (response['status'] === "PUBLISHED") {
          await router.push({name: 'reportDetail', params: { pageID: response['page']['id'], page: response['page']}});
        }  else {
          commit('setServerSideResponse', {
            "hasResponse": true,
            "responseType": 'success',
            "header": "Your report is on it's way!",
            "message": "report-is-on-the-way",
          });
        }
      } catch (e) {
        commit('setLoading', false, { root: true });
        commit('setServerSideResponse', {
          "hasResponse": true,
          "responseType": 'danger',
          "header": "oops",
          "message": "unable-to-get-estimate",
        });
      }
    },

    autoCompleteHandler: async ({ commit, state }) => {
        let address = state.searchForm.address.trim();
        if (address.length <= 3) {
          // do nothing when the input length is less than 3
          return false;
        }

        try {
          let results = await API.autoComplete(address);
          if (results.length > 0)
            commit('setAutoCompleteResponse', {
              isOpen: true,
              results: results,
              arrowCounter: -1,
            })
        } catch (e) {
          console.log(e);
          return false;
        }
    },
  },
  getters: {
    searchForm: state => state.searchForm,
    serverSideResponse: state => state.serverSideResponse,
    autoComplete: state => state.autoComplete,
  }
}
